import {PageTemplateSlugEnum} from '@core/models/page-template-slug-enum';

export class LoadPageTemplate {
  static readonly type = '[PageTemplate] Load page template';

  constructor(readonly slug: PageTemplateSlugEnum | string) {}
}
